export default __webpack_public_path__ + "static/media/4.646353f3.jpg";